export default __webpack_public_path__ + "static/media/Rishabh.318aaae7.png";